"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ward.dto.js.map